import Image from 'next/image'
import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

import { formatDateRange } from './formatDateRange'

interface IProposalMainDetailsProps {
  pictureUri: string
  title: string
  from?: Date
  to?: Date
  style?: CSSProperties
}

const ProposalMainDetails = ({
  pictureUri,
  title,
  from,
  to,
  style,
}: IProposalMainDetailsProps) => {
  return (
    <div className={s.container} style={style}>
      <Image
        className={s.image}
        src={pictureUri}
        alt='Image du lieu'
        width={50}
        height={50}
        style={{ objectFit: 'cover' }}
      />
      <div className={s.labelsContainer}>
        <div className={s.title}>{title}</div>
      </div>
      {from && to && (
        <div className={s.dateRange}>
          <p>{formatDateRange(from, to)}</p>
        </div>
      )}
    </div>
  )
}

export default ProposalMainDetails
